import React, { useState, useEffect, useRef, useCallback } from "react";
import TableWrapper from "../../../core/BaseComponents/TableWrapper/TableWrapper";
import { Card, CircularProgress, Switch, Tooltip } from "@mui/material";
import { callAPI } from "../../../../axios";
import BasicModal from "../../../core/BaseComponents/Modal";
import Custom_Paingation from "../../../core/BaseComponents/Custom_Paingation";
import { updateMasterHotelActions } from "../../../../store/actions/UpdateMasterHotel/UpdateMasterHotelActions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { debounce } from 'lodash';
import { isValidRole } from "../../../../utils/utils";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import IndiaMapWithSTB from "./IndiaMap/IndiaMapWithSTB";

function HotelsDashboard() {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [hotelDashboardCount, setHotelDashboardCount] = useState({})
  const [hotelList, setHotelList] = useState([]);
  const [cdnsShowPopUp, setCdnsShowPopUp] = useState(false);
  const [rowData, setRowData] = useState(false);
  const [loader, setLoader] = useState(false);
  const [hotelTypeFilter, setHotelTypeFilter] = useState("")
  const [filterType, setFilterType] = useState("all")

  const recordsPerPage = 15;

  const { chainId } = useSelector((state) => state.chainIdReducer);

  const [selectedPage, setSelectedPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(1);
  const [paginationError, setPaginationError] = useState("")
  const [inputPageValue, setInputPageValue] = useState(1)


  const [searchText, setSearchText] = useState("");

  let validPermissionClassName = isValidRole("HOTEL_CONFIGURATION_MODIFY")
    ? ""
    : "btn-disable-permission";

  const renderCDSNS = (row) => {
    const [item, ...items] = row?.cdsns;
    return row?.cdsns?.length > 0 ? <span className="cursor-pointer" onClick={() => { setCdnsShowPopUp(true); setRowData(row) }}>{item} {items.length > 0 && (
      <><span>...</span><span className="ms-2 cdsn-count">+{items?.length}</span></>
    )}</span> : (
      <div>N.A</div>
    )
  }

  const initialRender = useRef(true);

  useEffect(()=>{
    if (initialRender.current) {
      initialRender.current = false
    }
    else {
      if(hotelDashboardCount?.tickerMessages?.length){
        hotelDashboardCount?.tickerMessages?.map((data)=>{
          return (
            toast(data, {
              closeButton: true,
              autoClose: 6000,
              position: 'top-right',
              type: 'error'
            })
          )
        })
        }
      }
  },[hotelDashboardCount])

  const columns = [
    { field: "hotelName", headerName: "Hotel Name", flex: 1 },
    { field: "contactNo", headerName: "Phone", flex: 1 },
    // { field: "email", headerName: "Email", flex: 1 },
    // { field: "entepriseChainId", headerName: "Chain ID", flex: 1 },
    {
      field: "CDSN", headerName: "Linked CDSNs", flex: 1,
      row: true, renderCell: renderCDSNS,
      sortDirection: false,
      disableSortIcon: true
    },
    {
      field: "logoUrl", headerName: "Logo", flex: 1,
      row: true, renderCell: (row) => row?.logoUrl === null ? "NA" : <div className="uploaded-image">
        <img src={row?.logoUrl} alt={row?.logoUrl} />
      </div>,
      sortDirection: false,
      disableSortIcon: true
    },
    // {
    //   field: "autoMode", headerName: "Auto Mode Status", flex: 1,
    //   row: true, renderCell: (row) => <Switch
    //       checked={row?.autoMode}
    //       disabled
    //       inputProps={{ "aria-label": "controlled" }}
    //       className={`${row?.autoMode ? 'switchuser-active' : 'switchuser-inactive'} edit-icon-disable`}
    //     />,
    //   sortDirection: false,
    //   disableSortIcon: true
    // },
  ];

  useEffect(() => {
    const apiPath = `/getHoteldashBoard`;
    setLoader(true);
    callAPI(apiPath, "GET")
      .then((response) => {
        setHotelDashboardCount(response)
        setLoader(false);
      })
      .catch((err) => { console.warn(err.message); setLoader(false); });
  }, [])

  const hotelListApi = () => {
    const apiPath = `hotel/search?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`;
    setLoader(true);
    callAPI(apiPath, "POST", { hotelName: searchText, viewType: hotelTypeFilter, isDashboardPage: true })
      .then((response) => {
        setHotelList(response?.hotelDetails?.map((data)=>({...data, sid:data.id})));
        setTotalPageCount(response?.totalPages ? response?.totalPages : 1)
        setPaginationError("")
        dispatch(updateMasterHotelActions())
        setLoader(false);
      })
      .catch((err) => { console.warn(err.message); setLoader(false); });
  };

  useEffect(() => {
    hotelListApi();
  }, [selectedPage, chainId, searchText, hotelTypeFilter]);

  useEffect(() => {
    setInputPageValue(1)
    setPaginationError("")
    setSelectedPage(1);
  }, [searchText, hotelTypeFilter]);

  const popupCloseHandler = () => {
    setCdnsShowPopUp(false);
  };

  const DownloadTextFile = (headings, fileName) => {
    const columnHeaders = 'CDSN\n';
    const textArray = headings?.map((category) => {
      const categoryText = `${category?.header}\n`; // Section heading
      const categoryBody = category?.body?.map((item) =>
        `${item?.length ? item : 'NA'}`)?.join('\n'); // Data rows with SID and CDSN
      return `${categoryText}${columnHeaders}${categoryBody || 'No data available'}\n`; // Include the column headers before the data
    });

    const fileText = textArray?.join('\n');
    const blob = new Blob([fileText], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  const downLoadFile = () => {
    const fileName = `${rowData?.hotelName}_${rowData?.hotelChainId}_CDSNs.csv`;
    const headings = [
      { header: `List of "${rowData?.hotelName}" Linked CDSN's`, body: rowData?.cdsns?.length ? rowData?.cdsns : [{ sid: 'NA', cdsn: ['NA'] }] }
    ];
    DownloadTextFile(headings, fileName);
  };


  //Pagination Handle changer
  const onPageChange = (event, value) => {
    setInputPageValue(value)
    setPaginationError("")
    setSelectedPage(value);
  };

  const handleSearch = (search) => {
    setSearchText(search)
  };

  const delayedSearch = useCallback(
    debounce((searchText) => handleSearch(searchText), 600),
    []
  );

  return (
    <>
      <p className="mb-1 ms-1"><b>Hotels Dashboard</b></p>
      <div className="hotel-dashboard">
            <Card className={`dashboard-non-clickable `}>
              <p>Total CDSN's</p>
              <h6>{hotelDashboardCount?.totalCdsn ? hotelDashboardCount?.totalCdsn : 0}</h6>
            </Card>
            <Card className={`dashboard-non-clickable `}>
              <p>HMS CDSN's</p>
              <h6>{hotelDashboardCount?.hmsCdsn ? hotelDashboardCount?.hmsCdsn : 0}</h6>
            </Card>
            <Card className={`dashboard-non-clickable `}>
              <p>IHCL CDSN's</p>
              <h6>{hotelDashboardCount?.ihclCdsn ? hotelDashboardCount?.ihclCdsn : 0}</h6>
            </Card>
          </div>
      <div className="hotel-dashboard">
            <Card className={`cursor-pointer ${hotelTypeFilter === "" ? "activeHotelFilter" : ""}`} onClick={() =>{setHotelTypeFilter(""); setFilterType("all")}}>
              <p>Total Hotels</p>
              <h6>{hotelDashboardCount?.totalhotel ? hotelDashboardCount?.totalhotel : 0}</h6>
            </Card>
            <Card className={`cursor-pointer ${hotelTypeFilter === "custom" ? "activeHotelFilter" : ""}`} onClick={() => {setHotelTypeFilter("custom");setFilterType("HMS")}}>
              <p>HMS Hotels</p>
              <h6>{hotelDashboardCount?.hmsHotel ? hotelDashboardCount?.hmsHotel : 0}</h6>
            </Card>
            <Card className={`cursor-pointer ${hotelTypeFilter === "hotelApp" ? "activeHotelFilter" : ""}`} onClick={() => {setHotelTypeFilter("hotelApp");setFilterType("IHCL")}}>
              <p>IHCL Hotels</p>
              <h6>{hotelDashboardCount?.thirdPartyHotel ? hotelDashboardCount?.thirdPartyHotel : 0}</h6>
            </Card>
          </div>
      <div className="col-12 row">
        <div className="col-6">
          <IndiaMapWithSTB filterType={filterType} hotelDashboardCount={hotelDashboardCount} setLoader={setLoader}/>
        </div>
        <div className="col-6 px-0">
        <div className='row config-hotel'>
        <div className='left-column pe-0'>
          {loader && <div className="circular-progress"><CircularProgress /></div>}
          <div className="hotel-list">
            <div className="flex-items-between mb-3">
              <p className="mb-0"><b>Hotels List</b></p>
              <div className="d-flex">
                {isValidRole("HOTEL_CONFIGURATION_MODIFY") && <button onClick={() => navigate("/hms/ConfigurationNewHotel")} className={`create-btn mx-1 ${validPermissionClassName}`}>Add Hotel</button>}
                <div className="form-group-hotel mb-0">
                  <div className={`floating-label`}>
                    <input
                      id="search"
                      placeholder=""
                      className="form-control"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (!value) {
                          setSelectedPage(1);
                          setInputPageValue(1);
                        }
                        delayedSearch(value)
                      }}
                    />
                    <label htmlFor="guestName">Search Hotel</label>
                  </div>
                </div>
              </div>
            </div>
            <TableWrapper
              data={hotelList}
              columns={columns}
              module="hotel-config"
              noPagination={true}
            />
            <Custom_Paingation
              selectedPage={selectedPage}
              totalPageCount={totalPageCount}
              paginationError={paginationError}
              inputPageValue={inputPageValue}
              setSelectedPage={setSelectedPage}
              setPaginationError={setPaginationError}
              setInputPageValue={setInputPageValue}
              onPageChange={onPageChange}
            />
          </div>
        </div>
        {cdnsShowPopUp && <BasicModal
          popupOpen={cdnsShowPopUp}
          bodyMessage={
            <div className="text-start">
              <p className="px-3 pt-3">List of "<b>{rowData?.hotelName}</b>" Linked CDSNs</p>
              <div className="linked-sid-cdsns">
                <div className="sid-cdsn-list">
                  <div className="row sid-cdsn-list-header">
                    <h6 className="text-start">CDSN's</h6>
                  </div>
                  <div className="my-3 px-3">
                    {rowData?.cdsns?.map((items, index) =>
                      <span className="mb-1">{index ? ', ' : ''} {items}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          }
          customcss={true}
          footer={
            {
              primaryButton: {
                buttonName: "Cancel",
                action: popupCloseHandler,
                buttonPrimaryCustomCss: 'cancel-btn_new'
              }
              ,
              secondaryButton: {
                buttonName: "Download",
                action: downLoadFile
              }
            }
          }
        />}
      </div>
        </div>
      </div>
      
    </>
  )
}

export default HotelsDashboard;